import { render, staticRenderFns } from "./Overtime2.vue?vue&type=template&id=0051dbdc&scoped=true"
import script from "./Overtime2.vue?vue&type=script&lang=js"
export * from "./Overtime2.vue?vue&type=script&lang=js"
import style0 from "./Overtime2.vue?vue&type=style&index=0&id=0051dbdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0051dbdc",
  null
  
)

export default component.exports